import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import LiveGamePage from './pages/LiveGamePage'
import FinishedGamePage from './pages/FinishedGamePage'
import UpcomingGamePage from './pages/UpcomingGamePage'
import HowItWorksPage from './pages/HowItWorksPage'
import AnalyticsPage from './pages/AnalyticsPage'
import InfoPage from './pages/InfoPage'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/live/:gameId" element={<LiveGamePage />} />
        <Route path="/finished/:gameId" element={<FinishedGamePage />} />
        <Route path="/upcoming/:gameId" element={<UpcomingGamePage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/info" element={<InfoPage />} />
      </Routes>
    </Layout>
  )
}

export default App

